export enum Operators {
  GREATER = '>',
  LESS = '<',
  EQUAL = '='
}